package com.sddamico.draftmachine.api

import kotlinx.serialization.Serializable

// Mirror of the jvmMain `ErrorResponse`. [field] optionally names the offending request field
// (e.g. the content check flagging a pool's "name") so forms can mark the exact input.
@Serializable
data class ErrorResponse(val error: String, val field: String? = null)
